module.exports = __webpack_public_path__ + "static/media/menu-mobile-close.148f513f.svg";